import React from 'react';

import { FieldArray, FieldArrayRenderProps, useFormikContext } from '~src/settings/FormikWrapperForStubbing';
import { IRemoteQueryAgent } from '~src/settings/types/ISiteAdminBridgeSettings';
import { IRemoteAgentConnectionStatus } from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

import { SiteBridgeSettingsForSiteAdminProps } from '../../../bridge-settings/BridgeSiteSettings';
import { REMOTE_AGENTS_FIELD } from '../BridgeRemoteAgentsSection/BridgeRemoteAgentsSectionBody';
import { BridgeRemoteAgentsSectionHeaders } from '../BridgeRemoteAgentsSection/BridgeRemoteAgentsSectionHeaders';
import { BridgeRemoteAgentsTableRow } from '../BridgeRemoteAgentsSection/BridgeRemoteAgentsTableRow';
import { PoolAssignmentOption } from '../types/PoolAssignmentOption';
import { PoolID } from '../types/PoolID';
import { multiPoolTableStyle } from './BridgeMultiPoolSection';

export type MultiPoolTableEntryAgentsProps = Readonly<{
  agents: IRemoteQueryAgent[];
  connectionStatuses: IRemoteAgentConnectionStatus[];
  poolOptions: ReadonlyArray<PoolAssignmentOption>;
  siteId: string;
  agentPoolId: PoolID;
  refreshEdgePools: () => void;
}>;

export function BridgeMultiPoolTableEntryAgents(props: MultiPoolTableEntryAgentsProps) {
  const formik = useFormikContext<SiteBridgeSettingsForSiteAdminProps>();

  return (
    <table className={`${multiPoolTableStyle} tb-static-grid-table-remote-agents-width`}>
      <BridgeRemoteAgentsSectionHeaders isDefaultPool={true} />

      <tbody>
        <FieldArray
          name={REMOTE_AGENTS_FIELD}
          render={(arrayHelpers: FieldArrayRenderProps) => (
            props.agents.map((agent: IRemoteQueryAgent, index: number) => (
              <tr key={index}>
                <BridgeRemoteAgentsTableRow
                  agent={agent}
                  index={index}
                  connectionStatuses={props.connectionStatuses}
                  arrayHelpers={arrayHelpers}
                  poolTestId={''}
                  isDefaultPool={true}
                  formik={formik}
                  poolOptions={props.poolOptions}
                  siteId={props.siteId}
                  agentPoolId={props.agentPoolId}
                  refreshEdgePools={props.refreshEdgePools}
                />
              </tr>))
          )}
        />
      </tbody>
    </table>
  );
}
